import { inject, provide } from 'vue';

import type { IGroupItemProvide } from '@components/composable';
import type { Ref, InjectionKey } from 'vue';

export const CdsStepsGroupSymbol: InjectionKey<IGroupItemProvide> = Symbol.for('cds:steps-group');
export const CdsStepsSymbol: InjectionKey<ICdsStepsProvide> = Symbol.for('cds:steps');

interface ICdsStepsProvide {
  readonly: Ref<boolean>;
  interactive: Ref<boolean>;
  vertical: Ref<boolean>;
}

export const useProvideSteps = (data: ICdsStepsProvide) => {
  provide(CdsStepsSymbol, data);
};

export const useInjectSteps = () => {
  return inject(CdsStepsSymbol, {} as ICdsStepsProvide);
};
